<template>
	<div ref="imageContainer" class="uk-text-center lazy-image">
		<div v-if="!isLoaded" class="shimmer-effect"></div>
		<!-- Check if link prop has a value -->
		<a v-if="link" :href="link" target="_blank">
			<img
				v-if="isLoaded"
				:src="src"
				:alt="alt"
				:class="imageClassName"
				:style="{ height: scaledHeight + 'px' }"
				@load="handleLoad"
				@error="handleError"
			>
		</a>
		<!-- Display image without link if link prop is empty -->
		<img
			v-else-if="isLoaded"
			:src="src"
			:alt="alt"
			:class="imageClassName"
			:style="{ height: scaledHeight + 'px' }"
			@load="handleLoad"
			@error="handleError"
			@click="handleClick"
		>
	</div>
</template>


<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const props = defineProps({
	index: Number,
	src: String,
	alt: String,
	imageClassName: String,
	originalWidth: {
		type: Number,
		required: false,
	},
	originalHeight: {
		type: Number,
		required: false,
	},
	maxWidth: {
		type: Number,
		default: 600
	},
	maxHeight: {
		type: Number,
		default: 0.70
	},
	swiperId: {
		type: String,
		default: 'entry-media-swiper'
	},
	link: {
		type: String,
		default: null
	}
});

const isLoaded = ref(false);
const imageContainer = ref(null);
const lightbox = ref(null);

// Use computed property to calculate the scaled height.
const scaledHeight = computed(() => {
	
	if(props.originalWidth == null || 
		props.originalWidth == '' ||
		props.originalHeight == '' ||
		props.originalHeight == null ||
		props.originalWidth == 0 ||
		props.originalHeight == 0 ||
		typeof props.originalWidth == "undefined" ||
		typeof props.originalHeight == "undefined" 
	) {
		return 500;
	}
	
	const containerWidth = imageContainer.value ? imageContainer.value.clientWidth : props.maxWidth;
	const viewportHeight = window.innerHeight;
	let newHeight = (props.originalHeight * containerWidth) / props.originalWidth;
	const maxHeight = viewportHeight * props.maxHeight; // example: 0.75 = 75% of the viewport height

	// Ensure the new height does not exceed 75% of the viewport height.
	newHeight = Math.min(newHeight, maxHeight);

	return newHeight;
});

const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				isLoaded.value = true;
				observer.unobserve(entry.target);
			}
		});
	},
	{
		root: null,
		rootMargin: '0px',
		threshold: 0.1
	}
);

const handleClick = () => {
	if(props.link) {
		window.location = props.link;
		
		let a= document.createElement('a');
		a.target= '_blank';
		a.href= props.link;
		a.click();
				
	}	else {
		toggleSwiper()
	}
};

const toggleSwiper = () => {

	lightbox.value = new PhotoSwipeLightbox({
		gallery: '#' + props.id,
		children: 'a',
		showHideAnimationType: 'none',
		pswpModule: () => import('photoswipe'),
	});

	lightbox.value.on('beforeOpen', () => {
		console.log('beforeOpen')
	});
	lightbox.value.on('close', () => {
		console.log('close');
	});
		
	lightbox.value.init();
	
	lightbox.value.loadAndOpen(props.index-1,{
		gallery: document.querySelector('#' + props.swiperId)
	});
	
};

const handleLoad = () => {
	isLoaded.value = true;
};

const handleError = (e) => {
	e.target.src = 'https://placehold.co/500x500/red/white?text=Afbeelding+stuk+jonge';
};

// Listen to resize events to update the height based on the viewport size.
const onResize = () => {
	scaledHeight.value; 
};

//window.addEventListener('resize', onResize);

onMounted(() => {
	if (imageContainer.value) {
		observer.observe(imageContainer.value);
	}
});

onUnmounted(() => {
	if (observer && imageContainer.value) {
		observer.unobserve(imageContainer.value);
	}
	observer.disconnect();
	//window.removeEventListener('resize', onResize);
});

</script>

<style>
.image-container {
	position: relative;
	overflow: hidden;
	max-width: 600px;
	width: 100%;
}

.shimmer-effect {
	width: 100%;
	height: 100%;
	background: #f6f7f8;
	background-image: linear-gradient(to right, #eeeeee 0%, #dddddd 50%, #eeeeee 100%);
	background-repeat: no-repeat;
	background-size: 2000px 100%;
	animation: shimmer 2s infinite linear;
}

@keyframes shimmer {
	0% {
		background-position: -2000px 0;
	}
	100% {
		background-position: 2000px 0;
	}
}
</style>
